import { Form } from 'src/app/models/form.model';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, ViewChild } from "@angular/core";
import { UserService } from 'src/app/services/user.service';
import * as FormActions from '../../reducers/actions/forms.actions';
import * as FinalFormactions from '../../reducers/actions/form_final.actions';
import { SidenavService } from 'src/app/services/sidenav.service';
import { GLOBAL } from 'src/app/services/global';
import { FinalForm } from 'src/app/models/final_form.model';
import { MatSidenav } from '@angular/material/sidenav';


interface AppState {
  form: Form;
}
interface AppStateFinalForm {
  formFinal: FinalForm
}
@Component({
  selector: "page-instructions",
  templateUrl: "./instructions.component.html",
  styleUrls: ["./instructions.component.css"],
  providers: [UserService]
})
export class InstructionsComponent {
  // private showModule = GLOBAL.showModule;
  public identity;
  public token;
  public active;
  public imgSrc = "assets/permisos/document.svg";
  public forms = [];
  public formularios = [];
  public materias: any = [];
  public actives = [];
  public existForm;
  public numberForm;
  public iconosPermisos = ["assets/permisos/obramenor.svg", "assets/permisos/edificacion.svg", "assets/permisos/houses.svg",
    "assets/permisos/parquet.svg", "assets/permisos/profiles.svg", "assets/permisos/landslide.svg", "assets/permisos/antenna.svg",
    "assets/permisos/worker.svg", "assets/permisos/fire-station.svg"]
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _userService: UserService,
    private store: Store<AppState>,
    private _sidenavService: SidenavService,
    private storeF: Store<AppStateFinalForm>
  ) {
    this.getFormularios();
  }
  @ViewChild('sidenav', { static: true }) public sidenav2: MatSidenav;


  ngOnInit() {
    if (!sessionStorage.getItem('identity-domCloud') || !sessionStorage.getItem('token-domCloud')) {
      this._router.navigate(['/']);

    }


    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    if (localStorage.getItem("form")) {
      this.active = false
    } else {
      this.active = true
    }


  }

  /*  getForm(id, title) {
     localStorage.clear();
     sessionStorage.removeItem('borrador');
     this.store.dispatch(new FormActions.FormUpdate(id, title))
     localStorage.setItem("form", id)
 
 
   } */

  ngDoCheck() {

    this.numberForm = localStorage.getItem("form")
    if (localStorage.getItem("form")) {
      this.existForm = true;

    } else {
      this.existForm = false;
    }
  }

  getFormularios() {
    this._userService.getFormularios().subscribe(
      (response) => {


        this.materias = response.materias;
        console.log("response", response.materias)
        console.log("response.materias[0].name", response.materias[0].name)


        this.getForms();
      },
      error => {
        console.log("main-nav.component.ts error", error)
      });
  }

  getForms() {
    this._userService.getForms().subscribe(
      (response) => {
        // console.log("getForms response", response.forms)
        this.formularios = response.forms;
        for (let index = 0; index < this.formularios.length; index++) {
          const element = this.formularios[index];
          this.forms[element.num] =
          {
            "name": element.name,
            "active": element.active,
            "counter": element.counter,
          }
        }
        this.forms.length = this.formularios.length;
        console.log("this.forms", this.forms)
      },
      error => {
        console.log("main-nav.component.ts error", error)
      });

  }



  getFormUsed() {//cual es el formulario más utilizado
    this._userService.getFormUser().subscribe(
      response => {
        this.forms = response;
      },
      error => {
        console.log(error)
      }
    )
  }

  openForms(num) {
    //Averiguar como mejorar y refactorizar codigo
    console.log('Datos Form ', num);
    if (num != 0) {
      this._sidenavService.open();
    }
    sessionStorage.setItem("expandedItem", num)
   
  }

  getForm(id?, title?, online?) {
    console.log(id, title, online)

    if (online) {

      localStorage.clear();
      sessionStorage.removeItem('borrador');
      this.store.dispatch(new FormActions.FormUpdate(id, title))
      this.storeF.dispatch(new FinalFormactions.FinalFormCreate({
        newFormValues: {
          formulario: '1.1',
          tipo_solicitud: 'prueba',
        }
      }))

      setTimeout(() => {
        this.storeF.dispatch(new FinalFormactions.FinalFormCreate({
          newFormValues: {
            proyectos: []
          }
        }))
      }, 2000)
      localStorage.setItem("form", id)
      this._userService.formMostUsed(id, title).subscribe(
        response => {
          console.log(response)
        },
        error => {
          console.log(error)
        }
      )
    }
    else {
      alert("El formulario seleccionado solo se puede realizar presencialmente")
    }

  }

}